export default "/images/more.svg?452b579c3389c44e5b393bef9e65ec9a";